import { useTranslation } from "react-i18next";

const ReportHeader = ({
  reportType,
  setReportType,
  onApply,
  onFilterClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="report-header">
      <div className="header-left">
        <i className="fas fa-chart-line"></i>
        <span className="report-title">{t(reportType)}</span>
      </div>
      <div className="header-right">
        <label
          htmlFor="report-type"
          style={{ marginRight: "10px", fontWeight: "bold", color: "#333333" }}
        >
          {t("report_type_label")}
        </label>
        <select
          id="report-type"
          className="report-type-dropdown"
          value={reportType}
          onChange={(e) => setReportType(e.target.value)}
        >
          <option value="service_usage_report">
            {t("service_usage_report")}
          </option>
          <option value="inactive_mass_report">
            {t("inactive_mass_report")}
          </option>
          <option value="detailed_account_status">
            {t("detailed_account_status")}
          </option>
          <option value="financial_report">
            {t("financial_report")}
          </option>
        </select>
        <button className="apply-btn" onClick={onApply}>
          {t("apply_button")}
        </button>
      </div>
    </div>
  );
};

export default ReportHeader;